/**
 * セクション管理ホームページ専用i18n定数
 */

export const ADMIN_HOME_I18N = {
  // ページタイトル
  title: {
    dashboard: $localize`:@@admin.home.title.dashboard:ダッシュボード`,
    dataUsage: $localize`:@@admin.home.title.dataUsage:データ使用量`,
  },
  // チャートラベル
  chart: {
    xAxisMonth: $localize`:@@admin.home.chart.xAxisMonth:月`,
    yAxisDataUsage: $localize`:@@admin.home.chart.yAxisDataUsage:使用データ量（GB）`,
  },
  // ラベル
  label: {
    remaining: $localize`:@@admin.home.label.remaining:残り`,
    monthOverMonth: $localize`:@@admin.home.label.monthOverMonth:前月比`,
  },
} as const;

export type AdminHomeI18n = typeof ADMIN_HOME_I18N;
